import React from 'react';
import jMoment from 'moment-jalaali';
import Datatable from 'components/customized/tables/datatable';
import {urlPrefix, get} from 'engine/dataServices';

const columnData = [
    {id: 'productImage', numeric: false, disablePadding: true, label: 'تصویر محصول'},
    {id: 'orderId', numeric: false, disablePadding: true, label: 'شناسه سفارش'},
    {id: 'productId', numeric: false, disablePadding: true, label: 'شناسه محصول'},
    {id: 'productName', numeric: false, disablePadding: true, label: 'نام محصول'},
    {id: 'count', numeric: false, disablePadding: true, label: 'تعداد'},
    {id: 'orderStatus', numeric: true, disablePadding: false, label: 'وضعیت سفارش'},
    {id: 'createdDate', numeric: true, disablePadding: false, label: 'تاریخ ثبت سفارش'}
];

class SupplyProductsComponent extends React.Component {
    constructor(props) {
        super(props);

        jMoment.loadPersian({dialect: 'persian-modern'});

        this.state = {
            data: []
        };
    }

    componentWillMount() {
        this.loadData();
    }

    async loadData() {
        const res = await get('Order/GetSupplyProducts');
        if (res.status == 200) {
            const resData = await res.json();
            let data = [];
            resData.map(x => {
                const _productImage = <img src={urlPrefix + x.ProductImage}
                                           style={{
                                               height: 70,
                                               borderRadius: 10,
                                               marginTop: 5,
                                               marginBottom: 5
                                           }}/>;

                const statusStyle = x.OrderStep < 4 ? "text-white bg-grey" : x.OrderStep < 6 ? "bg-amber" : x.OrderStep < 8 ? "text-white bg-danger" : "text-white bg-success";
                const status = <div className={` badge text-uppercase ${statusStyle}`}>{x.OrderStepDescription}</div>

                const item = {
                    productImage: _productImage,
                    orderId: x.OrderId,
                    productId: x.ProductId,
                    productName: x.ProductName,
                    count: x.Count,
                    orderStatus: status,
                    createdDate : jMoment(x.CreatedDate).format('LLL')
                }

                data.push(item);
            });
            this.setState({data});
        }
    }

    render() {
        const {data} = this.state;

        return (
            <div className="jr-card">
                <div className="jr-card-header d-flex align-items-center">
                    <h3 className="d-inline-block mb-0">تامین محصول</h3>
                    <span className="text-white badge badge-success">کالا های خواسته شده از شما</span>
                </div>
                <div>
                    <Datatable columnData={columnData} data={data}/>
                </div>
            </div>
        );
    }
}

export default SupplyProductsComponent;



// WEBPACK FOOTER //
// ./components/toliton/dashboard/supplyProducts/supplyProducts.js